module.exports = __webpack_public_path__ + "static/media/rect.b6b6fa5f.png";